interface Props {
  tableNo?: string;
  itemCount: number;
  onViewCart?: () => void;
  onClose?: () => void;
}

const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M6 6l12 12M18 6L6 18" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

const CartStrip = ({ tableNo, itemCount, onViewCart, onClose }: Props) => {
  if (itemCount <= 0) return null;

  return (
    <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full md:px-6 z-[55] px-3 py-3 flex items-center justify-between" style={{ backgroundColor: "#67AF7A" }} role="status" aria-live="polite">
      <div className="flex flex-col">
        {tableNo && (<span className="font-opensans text-[12px] text-white"> Table Number - {tableNo} </span>)}
        <span className="font-sansation font-bold text-[14px] text-white">
          {itemCount} {itemCount === 1 ? "Item" : "Items"} Added
        </span>
      </div>

      <div className="flex items-center gap-3">
        <button type="button" onClick={onViewCart} className="font-sansation font-bold text-[14px] text-white bg-transparent border-2 border-white rounded-[10px] px-4 py-1.5" >
          View Cart
        </button>

        <button
          type="button"
          aria-label="Dismiss"
          onClick={onClose}
          className="w-6 h-6 rounded-full border-2 border-white flex items-center justify-center bg-transparent p-0"
          style={{ borderColor: "#F25138" }}
        >
          <span className="w-5 h-5 rounded-full flex items-center justify-center" style={{ backgroundColor: "#F25138" }}>
            <CloseIcon />
          </span>
        </button>
      </div>
    </div>
  );
};

export default CartStrip;
